import { render } from "./VipPricesEdit.vue?vue&type=template&id=9d57127c"
import script from "./VipPricesEdit.vue?vue&type=script&lang=js"
export * from "./VipPricesEdit.vue?vue&type=script&lang=js"

import "./VipPricesEdit.vue?vue&type=style&index=0&id=9d57127c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__